import ServicesSection from "../Home/ServicesSection";
import WhyChooseUs from "../Home/WhyChooseUs";
import Hero from "../Home/Hero";
import EasySteps from "./EasySetps";
import Expertise from "./Expertise";

export default function Page() {
  return (
    <>
    <Hero/>
      <ServicesSection/>
      <Expertise showStatsCards={false}/>
      <WhyChooseUs />
      <EasySteps/>
      {/* <ClientMapBlog/> */}
      {/* <Blog/> */}
    </>
  );
}